var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tvlogin"},[_c('div',{staticClass:"score"},[_c('div',[_c('img',{staticClass:"qrcode",attrs:{"src":require("@assets/images/tv.png"),"alt":""}}),(_vm.status == 1)?_c('div',{staticClass:"title"},[_vm._v("登录成功")]):_c('div',{staticClass:"title"},[_vm._v("取消登录")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }